import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { TableLoadingSkeleton } from "src/shared/components/tables/table-loading-skeleton";
import { NoData } from "src/shared/components/tables/no-data";
import { Box, TablePagination, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useGeBranchesHistory } from "src/api/customers";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import TableActions from "./table-actions";

const BranchHistory = () => {
  const { t } = useTranslation("customers");
  const { t: generalT } = useTranslation("general");
  const { branchId } = useParams();
  const [total, setTotal] = useState<number>(0);
  const [pageNumber, setPageNumber] = useState<number>(0);

  // APIS
  const { data, isLoading, refetch } = useGeBranchesHistory({
    id: branchId as string,
  });

  const tableHeadText = [
    t("packageName"),
    t("subscriptionStartDate"),
    t("subscriptionEndDate"),
    t("status"),
    generalT("actions"),
  ];

  const emptyDataArr = data?.data.length === 0;

  const handleChangePage = (event: unknown, newPage: number) => {
    setPageNumber(newPage);
  };

  useEffect(() => {
    if (data) {
      setTotal(data.meta.total);
    }
  }, [data]);

  return (
    <Box p={{ xs: 2, sm: "8px 32px 32px 32px" }}>
      <Typography fontWeight={600} mb={1}>
        {t("history")}
      </Typography>
      <TableContainer component={Paper} variant="outlined">
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              {tableHeadText.map((item) => (
                <TableCell
                  key={item}
                  align="center"
                  sx={{ bgcolor: "#F9FAFB" }}
                >
                  {item}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          {isLoading ? (
            <TableLoadingSkeleton rowsLength={8} cellsLength={8} />
          ) : (
            <TableBody>
              {data?.data.map((row: any) => (
                <TableRow
                  key={row.id}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell align="center">{row.package?.name}</TableCell>
                  <TableCell align="center">{row.start_date}</TableCell>
                  <TableCell align="center">{row.end_date}</TableCell>
                  <TableCell align="center">{row.status_text}</TableCell>
                  <TableCell align="center">
                    <TableActions
                      rowId={row.id}
                      rowName={row.package?.name ?? ""}
                      rowStatus={row.status}
                      refetch={refetch}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          )}
        </Table>
        {emptyDataArr && <NoData />}
      </TableContainer>
      <TablePagination
        sx={{ mt: 1 }}
        rowsPerPageOptions={[20]}
        component="div"
        count={total}
        rowsPerPage={20}
        page={pageNumber}
        onPageChange={handleChangePage}
        showFirstButton
        showLastButton
      />
    </Box>
  );
};
export default BranchHistory;
